import React, { Fragment, useState } from "react";
import { Button, Chip, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { Article, PhotoLibrary } from "@mui/icons-material";
import { BtmReturnInspectionProduct, BtmReturnInspectionStatus } from "../model/btm-return-inspection-product";
import { BtmReturnRequest } from "../model/btm-return-request";
import { t } from "i18next";
import { BtmRequestInspectionGallery } from "./btm-request-inspection-gallery";

interface IBtmRequestInspectionSummaryProps {
    request: BtmReturnRequest;
}

export const BtmRequestInspectionSummary = (props: IBtmRequestInspectionSummaryProps) => {
    const [photoLibraryOpenFor, setPhotoLibraryOpenFor] = useState<BtmReturnInspectionProduct>();

    const handlePhotoLibraryClose = () => {
        setPhotoLibraryOpenFor(undefined);
    };

    return <Fragment>
        {photoLibraryOpenFor && <BtmRequestInspectionGallery item={photoLibraryOpenFor}
                                                             onClose={handlePhotoLibraryClose} />}
        <Paper elevation={0} className={"btm-request-details__section btm-request-details__section--main"}>
            <Typography variant={"h4"} color={"textPrimary"} className={"btm-request-details__title"}>
                <Article color={"primary"} fontSize={"large"} />
                <span>{t("components.blueBrandReturns.page.details.summary.title")}</span>
            </Typography>
            <Table className={"btm-request-inspection-table"}>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography className={"btm-request-inspection-table__title"}>
                                {t("components.blueBrandReturns.page.details.summary.column.product")}
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography className={"btm-request-inspection-table__title"}>
                                {t("components.blueBrandReturns.page.details.summary.column.status")}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.request.inspectionResult.map((d, index) =>
                        <TableRow key={`btm-request-inspection-${index}`}>
                            <TableCell>1 X {d.productName}</TableCell>
                            <TableCell>
                                <div>
                                    <BtmInspectionStatusChip status={d.status} />
                                    {(d.files?.length ?? 0) > 0 &&
                                        <Button variant={"outlined"} color={"secondary"}
                                                startIcon={<PhotoLibrary />}
                                                onClick={() => setPhotoLibraryOpenFor(d)}>
                                            {t("components.blueBrandReturns.page.photos.button", {
                                                count: d.files?.length ?? 0,
                                            })}
                                        </Button>}
                                </div>
                                {d.comment && <Typography>{d.comment}</Typography>}
                            </TableCell>
                        </TableRow>)}
                </TableBody>
            </Table>
        </Paper>
    </Fragment>;
};

const BtmInspectionStatusChip = ({ status }: { status: BtmReturnInspectionStatus | undefined }) => {
    switch (status) {
        case BtmReturnInspectionStatus.Accepted:
            return <Chip label={t("components.blueBrandReturns.inspectionStatus.Accepted")}
                         variant={"filled"} color={"success"} />;
        case BtmReturnInspectionStatus.ConditionallyAccepted:
            return <Chip label={t("components.blueBrandReturns.inspectionStatus.ConditionallyAccepted")}
                         variant={"filled"} color={"warning"}  />;
        case BtmReturnInspectionStatus.Refused:
            return <Chip label={t("components.blueBrandReturns.inspectionStatus.Refused")}
                         variant={"filled"} color={"error"}  />;
        default:
            return <Chip label={t("components.blueBrandReturns.inspectionStatus.None")}
                         variant={"outlined"} color={"default"}  />;
    }
};
